import React from 'react';

const AdminMissingUsersTable = ({ missingUsers }) => {
  return (
    <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
      <thead>
        <tr>
          <th>Medios sin usuarios</th>
        </tr>
      </thead>
      <tbody>
          {missingUsers?.map((mediaName) => <tr><th>{mediaName}</th></tr>)}
      </tbody>
    </table>
  );
};

export default AdminMissingUsersTable;
